module.exports = __webpack_public_path__ + "img/ic_credit-card_payment-method-dark.de7bbb1.svg";